import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../app/store';
import { getAuthState } from '../../features/auth/selectors';

type Props = {
  isAuthorized: boolean;
  isPending: boolean;
  contentWithAuth: React.ReactElement;
  contentWithNoAuth: React.ReactElement;
  contentWithPending: React.ReactElement;
};

const ContentAuth: React.FC<Props> = (props) => {
  const { isAuthorized, isPending, contentWithAuth, contentWithNoAuth, contentWithPending } = props;

  if (isPending) {
    return contentWithPending;
  }

  if (isAuthorized) {
    return contentWithAuth;
  }

  return contentWithNoAuth;
};

const mapStateToProps = (state: RootState) => ({
  isAuthorized: getAuthState(state).isAuthorized,
  isPending: getAuthState(state).isPending,
});

export { ContentAuth };
export default connect(mapStateToProps)(ContentAuth);
